/**
 * Buttons settings to generate atomic classes.
 *
 * WARNING!!! `key` are required.
 * Other are used in iCMS
 */
const button = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'button', title: 'Button' },
    { key: 'button-1', title: 'Button 1' },
    { key: 'button-2', title: 'Button 2' },
    { key: 'button-3', title: 'Button 3' },
    { key: 'button-4', title: 'Button 4' },
    { key: 'button-5', title: 'Button 5' },
    { key: 'button-inline', title: 'Text Button' },
    { key: 'button-inline-1', title: 'Text Button 1' },
    { key: 'button-inline-2', title: 'Text Button 2' },
    { key: 'button-inline-extra-small', title: 'Text Button Extra Small' }
];
exports.button = button;
